import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';

const HeaderTopDropdownItem = ({ children, href, onClick, targetBlank }) => <li className="c-header-dropdown__item">
    <Button
      className="c-header-dropdown__link"
      color="none"
      fullWidth
      href={href}
      onClick={onClick}
      {...(targetBlank ? { target: '_blank' } : {})}
    >
      {children}
    </Button>
  </li>

export default HeaderTopDropdownItem;

HeaderTopDropdownItem.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  targetBlank: PropTypes.bool,
};

HeaderTopDropdownItem.defaultProps = {
  href: '',
  onClick: () => {},
  targetBlank: false,
};
